import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';
import { Norma } from '../_models/norma.model';
declare var jQuery:any;

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";

@Component({
  selector: 'formularionormas',
  templateUrl: 'formularionormas.template.html',
  //providers:  [PreguntasService]
})
export class FormularioNormasComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() idnorma: any;
  @Input() idmodulo: any;
  @Input() idarea: any;
  @Input() idbloque: any;
  @Input() copianorma: boolean;
  @Input() puedoeditar: boolean;

  @Output() onChangeNorma = new EventEmitter<boolean>();
  @Output() onCloseNorma = new EventEmitter<number>();

  id_norma: number;
  id_area: number;
  id_modulo: number;
  id_bloque: number;

  subscription: Subscription;

  listaAmbitos: any[];
  listaBloques: any[];
  listaAreas: any[];
  listaModulos: any[];

  id_ambito: number;

  norma: Norma;
  normaInicial: Norma;
  idambitoselect: number = 1;

  totalcomentarios: number = 0;
  totalenlaces: number = 0;

  //form: FormGroup;

  selectListaAmbitos: any[];

  alertaguardado : boolean = false;

  etiquetanorma: string = "";
  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  listacomunidades: any = [];
  listaprovincias: any = [];
  listamunicipios: any = [];
  listamarcos: any = [];
  listapaises: any = [];

  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private empresasService: EmpresasService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

  }

  cerrarNorma(destino:number){

    if (JSON.stringify(this.normaInicial) === JSON.stringify(this.norma)){
      this.alertaguardado = false;
      this.cerrarVentana(destino);
    }else{
      this.alertaguardado = true;
      jQuery(".columna").animate({scrollTop: 0}, 500);
    }
  }

  cerrarVentana(destino:number){
    this.onCloseNorma.emit(destino);
  }

  actualizaPadre(){
    this.onChangeNorma.emit(true);
  }

  cambioIdAmbito(valor){

  }

  cambioIdBloque(valor){
    this.getListaAreas(valor);
  }

  cambioIdArea(valor){
    this.getListaModulos(valor);
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idnorma']){
      this.id_norma = changes['idnorma'].currentValue;
    }
    if (changes['idarea']){
      this.id_area = changes['idarea'].currentValue;
    }
    if (changes['idbloque']){
      this.id_bloque = changes['idbloque'].currentValue;
    }
    if (changes['idmodulo']){
      this.id_modulo = changes['idmodulo'].currentValue;
    }
    if (changes['copianorma']){
      this.copianorma = changes['copianorma'].currentValue;
    }

    this.getListaAmbitos();
    this.getListaBloques();


    this.getNorma(this.id_norma);

    if (this.id_norma == 0){
      this.etiquetanorma = "Nueva norma";
    }else{
      this.etiquetanorma = "Editar norma";
    }
    if (!this.puedoeditar){
      this.etiquetanorma = "Norma";
    }

    this.getListaComunidades();
    this.getListaMarcos();
    this.getListaPaises();

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(formulario: NgForm, event: Event){
    event.preventDefault;
    //console.log(formulario);

    let norma: any;

    norma = {
      id_norma : this.norma.id_norma,
      abr: this.norma.abr,
      descripcion: this.norma.descripcion,
      id_ambito: this.norma.id_ambito,
      id_ambito_internacional: this.norma.id_ambito_internacional,
      id_ambito_nacional: this.norma.id_ambito_nacional,
      id_ambito_autonomico: this.norma.id_ambito_autonomico,
      id_ambito_provincial: this.norma.id_ambito_provincial,
      id_ambito_local: this.norma.id_ambito_local,

      id_modulo: this.norma.id_modulo,
      id_bloque: this.norma.id_bloque,
      id_area: this.norma.id_area,
      comentarios: this.norma.comentarios,
      enlaces: this.norma.enlaces,
      id_copia: this.norma.id_copia
    };

    //console.log(JSON.stringify(norma));
    this.copianorma = false;

    this.normasService.setNorma(norma).subscribe(
      data => {
        if (data){
          console.log (data.json());

          let al: any = {
            "texto" : "Norma guardada",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateNorma(data);
        }
      }
    );
  }

  getListaAmbitos(){
    this.normasService.getListaAmbitos().subscribe(
      data => {
        if (data){
          this.listaAmbitos = data.json().lista;
        }
      }
    );
  }

  getListaBloques(){
    this.normasService.getListaBloques().subscribe(
      data => {
        if (data){
          this.listaBloques = data.json().lista;
        }
      }
    );
  }

  getListaAreas(id_bloque: number){

    this.normasService.getListaAreas(id_bloque).subscribe(
      data => {
        if (data){
          this.listaAreas = data.json().lista;

          if (id_bloque == this.normaInicial.id_bloque){
            this.norma.id_area = this.normaInicial.id_area;
          }else{
            this.norma.id_area = -1;
          }

          this.getListaModulos(this.norma.id_area);
        }

      }
    );
  }

  getListaModulos(id_area: number){

    this.normasService.getListaModulos(id_area).subscribe(
      data => {
        if (data){
          this.listaModulos = data.json().lista;

          if (id_area == this.normaInicial.id_area){
            this.norma.id_modulo = this.normaInicial.id_modulo;
          }else{
            this.norma.id_modulo = -1;
          }
        }

      }
    );
  }

  anadirComentario(){
    var nuevocomentario: any = { id_comentario: 0, comentario: "", visible: true };
    this.norma.comentarios.push(nuevocomentario);
  }

  anadirEnlace(){
    var nuevoenlace: any = { id_enlace: 0, enlace: "", visible: true };
    this.norma.enlaces.push(nuevoenlace);
  }

  borrarComentario(i){
    this.norma.comentarios[i].visible = false;
    this.norma.comentarios[i].comentario = "";
  }

  borrarEnlace(i){
    this.norma.enlaces[i].visible = false;
    this.norma.enlaces[i].enlace = "";
  }

  getNorma(id_norma){

    this.norma = new Norma();

    this.normasService.getNorma(id_norma).subscribe(
      data => {

        /*if (id_norma != 0){

          this.norma.abr = data.json().norma.abr;
          this.norma.descripcion = data.json().norma.descripcion;
          this.norma.id_ambito = data.json().norma.id_ambito;
          this.norma.id_norma = data.json().norma.id_norma;
          this.norma.id_modulo = data.json().norma.id_modulo;
          this.norma.id_bloque = data.json().norma.id_bloque;
          this.norma.id_area = data.json().norma.id_area;
          this.norma.comentarios = data.json().norma.comentarios;
          this.norma.enlaces = data.json().norma.enlaces;

        }else{
          this.norma.id_area = this.id_area;
          this.norma.id_modulo = this.id_modulo;
          this.norma.id_bloque = this.id_bloque;
          this.norma.comentarios = [];
          this.norma.enlaces = [];
        }

        this.totalcomentarios = this.norma.comentarios.length;
        this.totalenlaces = this.norma.enlaces.length;

        this.normaInicial = new Norma();
        this.normaInicial.abr = this.norma.abr;
        this.normaInicial.descripcion = this.norma.descripcion;
        this.normaInicial.id_ambito = this.norma.id_ambito;
        this.normaInicial.id_norma = this.norma.id_norma;
        this.normaInicial.id_modulo = this.norma.id_modulo;
        this.normaInicial.id_bloque = this.norma.id_bloque;
        this.normaInicial.id_area = this.norma.id_area;
        this.normaInicial.comentarios = this.norma.comentarios;
        this.normaInicial.enlaces = this.norma.enlaces;

        for (let i=0; i < this.norma.comentarios.length; i++){
          this.norma.comentarios[i].visible = true;
        }

        for (let i=0; i < this.norma.enlaces.length; i++){
          this.norma.enlaces[i].visible = true;
        }


        this.getListaAreas(this.norma.id_bloque);*/
        if (data){
          this.updateCampos(data,id_norma);
        }

      }
    );
  }

  updateCampos(data, id_norma){

    console.log(data.json());

    if (id_norma != 0){

      this.norma.abr = data.json().norma.abr;
      this.norma.descripcion = data.json().norma.descripcion;
      this.norma.id_ambito = data.json().norma.id_ambito;
      this.norma.id_ambito_internacional = data.json().norma.id_ambito_internacional;
      this.norma.id_ambito_nacional = data.json().norma.id_ambito_nacional;
      this.norma.id_ambito_autonomico = data.json().norma.id_ambito_autonomico;
      this.norma.id_ambito_provincial = data.json().norma.id_ambito_provincial;
      this.norma.id_ambito_local = data.json().norma.id_ambito_local;
      this.norma.id_norma = data.json().norma.id_norma;
      this.norma.id_modulo = data.json().norma.id_modulo;
      this.norma.id_bloque = data.json().norma.id_bloque;
      this.norma.id_area = data.json().norma.id_area;
      this.norma.comentarios = data.json().norma.comentarios;
      this.norma.enlaces = data.json().norma.enlaces;
      this.norma.ambito = data.json().norma.ambito;
      this.norma.bloque = data.json().norma.bloque;
      this.norma.area = data.json().norma.area;
      this.norma.modulo = data.json().norma.modulo;

      this.norma.ambitoNacional = data.json().norma.ambitoNacional;
      this.norma.ambitoInternacional = data.json().norma.ambitoInternacional;
      this.norma.ambitoProvincial = data.json().norma.ambitoProvincial;
      this.norma.ambitoLocal = data.json().norma.ambitoLocal;
      this.norma.ambitoAutonomico = data.json().norma.ambitoAutonomico;

    }else{
      this.norma.id_area = this.id_area;
      this.norma.id_modulo = this.id_modulo;
      this.norma.id_bloque = this.id_bloque;
      this.norma.comentarios = [];
      this.norma.enlaces = [];
    }

    if (this.copianorma){
      this.norma.id_copia = this.norma.id_norma;
      this.norma.id_norma = 0;
      this.norma.abr = "(Copia) " + this.norma.abr;
      this.norma.descripcion = "(Copia) " + this.norma.descripcion;
    }

    this.totalcomentarios = this.norma.comentarios.length;
    this.totalenlaces = this.norma.enlaces.length;

    this.normaInicial = new Norma();
    this.normaInicial.abr = this.norma.abr;
    this.normaInicial.descripcion = this.norma.descripcion;
    this.normaInicial.id_ambito = this.norma.id_ambito;
    this.normaInicial.id_ambito_internacional = this.norma.id_ambito_internacional;
    this.normaInicial.id_ambito_nacional = this.norma.id_ambito_nacional;
    this.normaInicial.id_ambito_autonomico = this.norma.id_ambito_autonomico;
    this.normaInicial.id_ambito_provincial = this.norma.id_ambito_provincial;
    this.normaInicial.id_ambito_local = this.norma.id_ambito_local;
    this.normaInicial.id_norma = this.norma.id_norma;
    this.normaInicial.id_modulo = this.norma.id_modulo;
    this.normaInicial.id_bloque = this.norma.id_bloque;
    this.normaInicial.id_area = this.norma.id_area;
    this.normaInicial.comentarios = this.norma.comentarios;
    this.normaInicial.enlaces = this.norma.enlaces;
    this.normaInicial.ambito = this.norma.ambito;
    this.normaInicial.bloque = this.norma.bloque;
    this.normaInicial.area = this.norma.area;
    this.normaInicial.modulo = this.norma.modulo;

    this.normaInicial.ambitoNacional = this.norma.ambitoNacional;
    this.normaInicial.ambitoInternacional = this.norma.ambitoInternacional;
    this.normaInicial.ambitoProvincial = this.norma.ambitoProvincial;
    this.normaInicial.ambitoLocal = this.norma.ambitoLocal;
    this.normaInicial.ambitoAutonomico = this.norma.ambitoAutonomico;

    for (let i=0; i < this.norma.comentarios.length; i++){
      this.norma.comentarios[i].visible = true;
    }

    for (let i=0; i < this.norma.enlaces.length; i++){
      this.norma.enlaces[i].visible = true;
    }

    this.getListaAreas(this.norma.id_bloque);

    if (this.norma.id_ambito_autonomico != 0){
      this.getListaProvincias(this.norma.id_ambito_autonomico);
    }

    if (this.norma.id_ambito_provincial != 0){
      this.getListaMunicipios(this.norma.id_ambito_provincial);
    }

  }

  updateNorma(data){

    this.norma = new Norma();

    this.updateCampos(data, this.id_norma);

    this.getListaAmbitos();
    this.getListaBloques();

    this.actualizaPadre();
  }

  editar(){
    this.puedoeditar = true;
    this.etiquetanorma = "Editar norma";
  }

  getListaMarcos(){

    let params = {
      action: "ListagetMarcos"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamarcos = data.json().lista;
          }
        }
    );

  }

  getListaPaises(){

    let params = {
      action: "ListagetPaises"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listapaises = data.json().lista;
          }
        }
    );

  }

  getListaComunidades(){

    let params = {
      action: "ListagetComunidades"
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listacomunidades = data.json().lista;
          }
        }
    );

  }

  getListaProvincias(id_comunidad: any){

    let params = {
      action: "ListagetProvincias",
      id_comunidad: id_comunidad
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listaprovincias = data.json().lista;
          }
        }
    );

  }

  getListaMunicipios(id_provincia: number){

    let params = {
      action: "ListagetMunicipios",
      id_provincia: id_provincia
    }

    this.empresasService.getSelect(params).subscribe(
        data => {
          if (data){
            this.listamunicipios = data.json().lista;
          }
        }
    );

  }

}



// WEBPACK FOOTER //
// ./src/app/normas/formularionormas.component.ts